module.exports = __webpack_public_path__ + "img/4.3ec06ed2.png";